import { Translatable, TranslateProperty } from '../../../core/helper/translatables';
import { ModelBase } from '../../../core/model/model-base';
import {
  B2CSubscriptionContactState,
  B2CSubscriptionContactStateToString,
  B2CSubscriptionState,
  B2CSubscriptionStateToString,
} from '../const/enum-b2c';
import { B2CSubscription } from './b2c-subscription';

// Used by the contact-form
export class B2CSubscriptionContact extends ModelBase {
  constructor() {
    super();
    TranslateProperty(this as B2CSubscriptionContact, 'state', B2CSubscriptionContactStateToString);
  }

  contact: B2CSubscriptionContactModel;
  contactId: string;

  subscription: B2CSubscription;
  subscriptionId: string;

  state: Translatable<B2CSubscriptionContactState>;
  stateChangedDate: Date;

  get isEnabled(): boolean {
    return this.state == B2CSubscriptionContactState.Enabled;
  }

  getSSN(): string {
    return this.subscription.identity.recipient?.substring(0, this.subscription.identity.recipient.indexOf('.'));
  }

  toString(culture?: string): string {
    return this.subscription.identity.recipient;
  }

  public static Map(source: B2CSubscriptionContact): B2CSubscriptionContact {
    if (!source) {
      return null;
    }
    const obj = Object.assign(new B2CSubscriptionContact(), source);
    obj.contact = B2CSubscriptionContactModel.Map(source.contact);
    obj.subscription = B2CSubscription.Map(source.subscription);
    return obj;
  }
}

export class B2CSubscriptionContactModel extends ModelBase {
  constructor() {
    super();
  }

  contactIdentification: string;
  createdAt: Date;
  number: number;
  name: string;
  email: string;
  note: string;
  isArchived: boolean;

  public static Map(source: B2CSubscriptionContactModel): B2CSubscriptionContactModel {
    return Object.assign(new B2CSubscriptionContactModel(), source);
  }
}
